import Exception from './Exception';

export default class EmptyResultsException extends Exception {
  constructor(message) {
    super('Empty results exception', message);
  }
}
